import { useMemo } from "react";

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useNavigationFactory = ({ fetch, siteSelected: { id: siteId }, collections: { collectionsURL } }) => useMemo(() => ({
  reorder: async data => {
    const result = await fetch({
      method: 'put',
      url: `${collectionsURL}/reorder`,
      data,
      params: { siteId },
    });

    if (!result) {
      throw Error()
    }

    return result
  },
}), [fetch, siteId, collectionsURL])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('cms/navigation')
  .extendHookCollectionsFactory('cms/navigations')
  .extend(useNavigationFactory)
  .factory()

export {
  Provider as NavigationProvider,
  useStore as useNavigationStore,
}
